module.exports = __webpack_public_path__ + "static/media/icon-team-survey-progress-completed.c54d4252.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-team-survey-progress-completed.svg
// module id = 1901
// module chunks = 0